import GridRoute from 'eflex/util/grid-route';
import { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { task } from 'ember-concurrency';
import JobStatuses from 'eflex/constants/kinetic-job-statuses';
import { TrackedArray } from 'tracked-built-ins';

export default class KineticJobsInQueueRoute extends GridRoute {
  @service store;

  getData = task(waitFor(async (params = {}) => {
    const results = await this.store.query('kinetic-assembly-operation', {
      jobStatus: JobStatuses.released,
      ...params,
    });
    const data = new TrackedArray(results);
    data.meta = { count: results.meta?.count ?? 0 };

    return data;
  }));
}
